import { Book } from '../book/book';

export enum StoryState {
    Active = 'active',
    Live = 'live',
}

export enum PurchaseCurrencyOption {
    None = 0,
    HeartsOnly = 1,
    SapphiresOnly = 2,
    HeartsOrSapphires = 3,
}

export type RewardPurchaseListing = {
    currency: PurchaseCurrencyOption;
    costInHearts: number,
};

export enum EpisodeRunners {
  RenPy = 'renpy',
  Dorian = 'dorian',
}

export enum StoryOrientation {
  UNSET = 0,
  VERTICAL = 1,
  HORIZONTAL = 2,
}

export const StoryOrientationLabels = {
  [StoryOrientation.UNSET]: 'Unset',
  [StoryOrientation.VERTICAL]: 'Vertical (Phone)',
  [StoryOrientation.HORIZONTAL]: 'Horizontal (Tablet/PC)',
};

export type StoryRenpyData = {
  content_url: string,
  orientation: StoryOrientation,
}

export type Story = {
    id: number,
    title: string
    uuid: string,
    internal_uuid: string,
    author?: string,
    summary: string,
    genreId: number,
    chapter: number,
    version: string,
    isTemplate: boolean,
    createdAt: string,
    updatedAt: string,
    bookId: number,
    contestWinner: boolean,
    originalStoryId?: number,
    deleted: boolean,
    public: boolean,
    revision: number,
    fromTemplate: boolean,
    coverLocationId?: number,
    coverCharacterId?: number,
    coverCharacterExpressionId?: number,
    displaySettings: unknown,
    recommendations: unknown,
    community_share: boolean,
    live_count: number,
    book: Book,
    usedAsTemplate: number,
    group: string,
    analytics: unknown,
    tags: string[],
    story_role: string,
    users: (string | number)[],
    isBonus?: boolean,
    isLocked: boolean,
    purchaseListings: RewardPurchaseListing[] | undefined,
    runner: EpisodeRunners | null | undefined;
    renpyData: StoryRenpyData | null;
}
